Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tikTokClassNames = exports.handleTikTokLoad = void 0;
var _utils = require("../../utils");
var isTikTokScriptAdded = false;
var tikTokClassNames = ".tiktok-embed";
exports.tikTokClassNames = tikTokClassNames;
var tikTokEmbedUrl = "https://www.tiktok.com/embed.js";
var handleTikTokLoad = function handleTikTokLoad() {
  if (!isTikTokScriptAdded) {
    (0, _utils.createScriptTag)(tikTokEmbedUrl, null);
    isTikTokScriptAdded = true;
    return {
      status: 'createScriptTag'
    };
  }
  return {
    status: 'null'
  };
};
exports.handleTikTokLoad = handleTikTokLoad;